const FILE_BLOCK_RE = /\[\[FILE:(.*?)\]\]\n?([\s\S]*?)\[\[\/FILE\]\]/g;
const PARTIAL_RE = /\[\[FILE:(.*?)\]\]\n?([\s\S]*)$/;

const LANG_MAP = {
  html: "html", htm: "html", css: "css", js: "javascript", jsx: "jsx",
  ts: "typescript", tsx: "tsx", json: "json", py: "python", md: "markdown",
};

export function languageFor(name) {
  const ext = name.includes(".") ? name.split(".").pop().toLowerCase() : "";
  return LANG_MAP[ext] || "text";
}

// Parse complete + in-progress file blocks from streaming text.
export function parseFiles(text) {
  const files = [];
  let match;
  const re = new RegExp(FILE_BLOCK_RE);
  let lastIndex = 0;
  while ((match = re.exec(text)) !== null) {
    let content = match[2];
    if (content.endsWith("\n")) content = content.slice(0, -1);
    files.push({ name: match[1].trim(), language: languageFor(match[1].trim()), content });
    lastIndex = re.lastIndex;
  }
  // Handle an in-progress (not yet closed) block for live typing effect
  const rest = text.slice(lastIndex);
  const partial = rest.match(PARTIAL_RE);
  if (partial && !partial[0].includes("[[/FILE]]")) {
    const name = partial[1].trim();
    if (name) {
      let content = partial[2] || "";
      if (content.endsWith("\n")) content = content.slice(0, -1);
      files.push({ name, language: languageFor(name), content, streaming: true });
    }
  }
  return files;
}

export function stripFileBlocks(text) {
  let cleaned = text.replace(FILE_BLOCK_RE, "");
  cleaned = cleaned.replace(/\[\[FILE:.*$/s, "");
  return cleaned.trim();
}

// Build an HTML document string for the preview iframe from project files.
export function buildPreview(files) {
  if (!files || files.length === 0) return "";
  const byName = {};
  files.forEach((f) => (byName[f.name] = f.content));
  let html = byName["index.html"] || byName["Index.html"];
  if (!html) {
    // No html entry: if only css/js, wrap; else show first html-ish file
    const htmlFile = files.find((f) => f.language === "html");
    html = htmlFile ? htmlFile.content : null;
  }
  if (!html) {
    const css = files.filter((f) => f.language === "css").map((f) => f.content).join("\n");
    const js = files.filter((f) => f.language === "javascript").map((f) => f.content).join("\n");
    html = `<!DOCTYPE html><html><head><style>${css}</style></head><body><script>${js}<\/script></body></html>`;
    return html;
  }
  // Inline local css references
  html = html.replace(/<link[^>]*href=["']([^"']+\.css)["'][^>]*>/gi, (m, href) => {
    const key = href.replace(/^\.?\//, "");
    const content = byName[key] || byName[href];
    return content !== undefined ? `<style>\n${content}\n</style>` : m;
  });
  // Inline local js references
  html = html.replace(/<script([^>]*)\ssrc=["']([^"']+\.js)["']([^>]*)><\/script>/gi, (m, pre, src, post) => {
    const key = src.replace(/^\.?\//, "");
    const content = byName[key] || byName[src];
    if (content === undefined) return m;
    const typeAttr = /type=/.test(pre + post) ? (pre + post).match(/type=["'][^"']*["']/)[0] : "";
    return `<script ${typeAttr}>\n${content}\n<\/script>`;
  });
  return html;
}
